"use client";

import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface FlyToCartProps {
  isFlying: boolean;
  startRect?: DOMRect;
  productImageUrl?: string;
  onDone?: () => void;
}

function getReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function FlyToCart({ isFlying, startRect, productImageUrl, onDone }: FlyToCartProps) {
  useEffect(() => {
    if (!isFlying) return;
    if (getReducedMotion()) {
      onDone?.();
      return;
    }
    const timer = setTimeout(() => {
      onDone?.();
    }, 800);
    return () => clearTimeout(timer);
  }, [isFlying, onDone]);

  if (!isFlying || !startRect || !productImageUrl) return null;

  const cartIcon = document.querySelector('[data-cart-icon]') as HTMLElement | null;
  let endX = window.innerWidth - 40;
  let endY = 20;

  if (cartIcon) {
    const cartRect = cartIcon.getBoundingClientRect();
    endX = cartRect.left + cartRect.width / 2;
    endY = cartRect.top + cartRect.height / 2;
  }

  const startX = startRect.left + startRect.width / 2;
  const startY = startRect.top + startRect.height / 2;

  return (
    <AnimatePresence>
      <motion.div
        initial={{
          x: startX - 40,
          y: startY - 40,
          scale: 1,
          opacity: 1,
        }}
        animate={{
          x: endX - 40,
          y: endY - 40,
          scale: 0.2,
          opacity: 0.3,
        }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.7, ease: "easeInOut" }}
        className="fixed top-0 left-0 z-[100] pointer-events-none"
        style={{ width: 80, height: 80 }}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={productImageUrl}
          alt=""
          width={80}
          height={80}
          className="rounded-md object-cover"
        />
      </motion.div>
    </AnimatePresence>
  );
}
